import * as React from 'react';

const SvgIconArrowRight = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.33301 2.66602L11.333 7.99935L5.33301 13.3327" stroke={props.color ? props.color : "black"} />
  </svg>
);

export default SvgIconArrowRight;
